import React from "react";
import "./Hospitality_Banner.css";

function Hospitality_Banner() {
  return (
    <section className="majesty_absolute_section">
      <div className="hospitality_banner">
        <img
          src="/assets/images/hospitality/banner-majesty.png"
          alt="Hospitality Banner"
          className="banner_img"
        />
      </div>
      <div className="container">
        {" "}
        <div className="majesty_box">
          <p className="title">
            Bring the indulgence of a five-star suite into your home with the
          </p>
          <h1 className="head">Majesty Absolute Bliss Mattress</h1>

          <div class="majesty-divider">
            <span></span>
          </div>

          <p className="description">
            Crafted to provide a premium hotel-style sleep experience, Majesty
            mattress features a sophisticated Euro top design. It is the
            ultimate solution for those who crave a plush, velvety surface but
            still require firm underlying support to soothe back and neck
            tension.
          </p>
        </div>
      </div>
    </section>
  );
}

export default Hospitality_Banner;
